module.exports = "https://bin.bnbstatic.com/_next/static/images/ecosystem-banner-6ce3288dc74e873bf2486a61790f0660.jpg";